import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import './quasar'
import '@/scss/helpers.scss'
import '@/scss/material-theme.scss'
import '@/scss/global-styles.scss'
import VueApollo from 'vue-apollo'
import Constants from './plugins/Constants'
import { apolloProvider } from './vue-apollo'
import { store } from './store'

Vue.use(Constants)

Vue.config.productionTip = false

// Disable apollo injection if testing
if (process.env.NODE_ENV !== 'test') {
  Vue.use(VueApollo)
}

new Vue({
  router,
  store,
  apolloProvider: apolloProvider,
  render: h => h(App)
}).$mount('#app')
